/**
 * click-tracker-service is an AMD module that returns
 * clickTrackerService implementation.
 * Api service.
 *
 * @summary track clicks on page
 * @version 0.1
 * @since 0.1
 * @module click-tracker-service
 */
define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function parentApiServiceImpl() {
  'use strict';

  var clickTrackerService = function clickTrackerService($window) {
    var trackElems = [
      {
        tagName: 'A'
      },
      {
        tagName: 'BUTTON'
      }
      // {
      //   tagName: 'PARENT-COLLAPSE-BLOCK-HEADER',
      //   attributes: {
      //     'data-collapsed': 'false'
      //   }
      // }
    ];

    var ClickTracker = function ClickTracker(_tracker, _baseElem) {
      this.tracker = _tracker;
      this.baseElem = _baseElem || $window.document.body;
      this.trackFn = this._track.bind(this);
      this.eventPayload = {
        /* eslint-disable */
        event_type: 'AOFL.READINGIQ_PRIVATE.V1.UserInterfaceClickEvent',
        payload: {}
      }; /* eslint-enable */
    };

    ClickTracker.prototype = {
      constructor: ClickTracker,
      init: function init() {
        this.baseElem.addEventListener('click', this.trackFn);
      },
      deInit: function deInit() {
        this.baseElem.removeEventListener('click', this.trackFn);
      },
      _track: function _track(e) {
        this.elem = this._findDomScope(e.target);
        if (this.elem) {
          this.tracker.enqueueEvent(
            Object.assign({}, this.eventPayload, {
              payload: {
                id: this.elem.getAttribute('dom-scope')
              }
            })
          );
        }
      },
      _shouldTrack: function _shouldTrack(elem) {
        for (var i = 0; i < trackElems.length; i++) {
          var trackElem = trackElems[i];
          if (elem.tagName === trackElem.tagName) {
            if (typeof trackElem.attributes === 'undefined') return true;
            for (var attrKey in trackElem.attributes) {
              if (!trackElem.attributes.hasOwnProperty(attrKey)) continue;
              if (
                trackElem.attributes[attrKey] === elem.getAttribute(attrKey)
              ) {
                return true;
              }
            }
          }
        }
        return false;
      },
      _findDomScope: function _findDomScope(_elem) {
        var elem = _elem;
        while (elem && elem !== this.baseElem) {
          var shouldTrack = this._shouldTrack(elem);
          if (shouldTrack && elem.getAttribute('dom-scope')) {
            return elem;
          }
          elem = elem.parentNode;
        }
        return false;
      }
    };

    return ClickTracker;
  };

  return clickTrackerService;
});
